import Stack from '@mui/material/Stack';
import StyledPrimaryFooter from './StyledPrimaryFooter';
import Text from '../Text/Text';
import FooterLinks from '../FooterLinks/FooterLinks';

const PrimaryFooter = (): JSX.Element => {
  const currentYear = new Date().getFullYear();

  return (
    <StyledPrimaryFooter>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Stack>
          <Text type="body2" color="#fff">
            &copy; {currentYear} Elora, SA
          </Text>
        </Stack>
        <FooterLinks color="#fff" />
      </Stack>
    </StyledPrimaryFooter>
  );
};

export default PrimaryFooter;
